import { createFileRoute } from '@tanstack/react-router'
import { OrderContractWorkspace, rentalBatchContractSearchSchema } from '@/features/order/index.ts'

export const Route = createFileRoute('/_authenticated/orders/rentals/contracts/batch')({
  validateSearch: rentalBatchContractSearchSchema,
  component: RentalBatchContractPage,
  head: () => ({ meta: [{ title: '批量生成租赁合同 · Super Mega' }] })
})

function RentalBatchContractPage() {
  const ids = Route.useSearch().ids
  const { currentSession } = Route.useRouteContext()
  return (
    <OrderContractWorkspace
      key={ids.join(':')}
      ids={ids}
      batch
      canManage={
        currentSession.isSuperAdmin ||
        currentSession.permissions.some(
          (permission) => permission.startsWith('order.rental.') && !permission.endsWith('.read')
        )
      }
    />
  )
}
